import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Button } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import Modal from "components/Modal";
import { hideSessionExpiredModal } from "../../redux/features/auth/sessionExpiredSlice";
import { isPublicAuthPath } from "utils/environment";
import { getLoginUrlWithReturn } from "utils/authReturnUrl";
import useAppDispatch from "hooks/useAppDispatch";
import { clearAuthClientState } from "utils/cookie";
import { beginLogoutTransition } from "utils/logoutTransition";

const redirectToLogin = () => {
  const loginUrl = getLoginUrlWithReturn();
  if (loginUrl.startsWith("http")) {
    window.location.replace(loginUrl);
    return;
  }
  window.location.assign(loginUrl);
};

const SessionExpiredModal = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const showModal = useSelector((state) => state.sessionExpired.showModal);

  const isActivationRoute = location.pathname.includes("/activation");
  const isInvitationRoute =
    location.pathname.startsWith("/join/accept") ||
    location.pathname.startsWith("/invitation") ||
    location.pathname.startsWith("/invite/accept") ||
    location.pathname.startsWith("/invite/profile");
  const onPublicAuthPath = isPublicAuthPath(location.pathname);
  const shouldShowModal =
    showModal && !isActivationRoute && !isInvitationRoute && !onPublicAuthPath;

  React.useEffect(() => {
    if ((isActivationRoute || isInvitationRoute || onPublicAuthPath) && showModal) {
      dispatch(hideSessionExpiredModal());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActivationRoute, isInvitationRoute, onPublicAuthPath, showModal]);

  const handleGoToLogin = () => {
    beginLogoutTransition();
    try {
      clearAuthClientState();
    } catch {
      /* ignore */
    }
    redirectToLogin();
  };

  return (
    <Modal
      visible={shouldShowModal}
      onClose={() => {}}
      title={t("auth.sessionExpired.title")}
      description={t("auth.sessionExpired.description")}
      iconType="warning"
      closeIconVisible={false}
      shouldCloseOnOverlayClick={false}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="primary" onClick={handleGoToLogin}>
            {t("auth.sessionExpired.reload")}
          </Button>
        </div>
      }
    />
  );
};

export default SessionExpiredModal;
